import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ResponseHelperService } from 'src/app/services/helpers/response-helper.service';
import { LocationService } from './../services/location.service';
import { PromotionService } from './../services/promotion.service';
import { BehaviorsService } from './../services/behaviors.service';
import { InstrumentTypeService } from './../services/instrument-type.service';
import { CommunicationsService } from './../services/communications.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AppDataService } from 'src/app/app-data.service';
import {
  faSearch,
  faCopy,
  faTimes,
  faCheck,
} from '@fortawesome/free-solid-svg-icons';
import { debounce } from 'rxjs/operators';
import { Observable, Subject } from 'rxjs';
import { fromEvent, interval } from 'rxjs';
import { parseResponse } from '../data/parseResponseFunction';
import { RewardTypeService } from '../services/reward-type.service';
@Component({
  selector: 'app-regex-search-modal',
  templateUrl: './regex-search-modal.component.html',
  styleUrls: ['./regex-search-modal.component.scss'],
})
export class RegexSearchModalComponent implements OnInit {
  //TODO add these
  @Input() searchFor: string;
  @Input() item: any;
  @Input() limitToOne: boolean;
  @Input() setValue: boolean;
  @Input() searchPattern: string;
  @Input() itemIndex: number;
  //item.object: any;
  results: any;
  result: any;
  select: any = {};
  checkedItems: any = [];
  searchResults: any;
  title: string;
  disableSearchType: boolean;
  faSearch = faSearch;
  faCopy = faCopy;
  faTimes = faTimes;
  faCheck = faCheck;
  fieldTypeRadio = 0;
  @Output() public successEvent: EventEmitter<any> = new EventEmitter(true);
  debouncer: Subject<string> = new Subject<string>();

  constructor(
    private http: HttpClient,
    private globalData: AppDataService,
    private responseHelperService: ResponseHelperService,
    private locationService: LocationService,
    private promotionService: PromotionService,
    private behaviorsService: BehaviorsService,
    private instrumentTypeService: InstrumentTypeService,
    private communicationsService: CommunicationsService,
    private rewardTypeService: RewardTypeService,
    public activeModal: NgbActiveModal,
    private modalHelper: NgbModal
  ) {
    this.debouncer
      .pipe(debounce(() => interval(1000)))
      .subscribe((value) => this.successEvent.emit(value));
  }

  ngOnInit(): void {
    this.select = {};
    this.title = 'Regex Code Search';

    this.item = this.item ? this.item : [];
    if (this.item.objectOfObjectName) {
      if (!this.item.object) {
        this.item.object = {};
      }
      //this.item.object = this.item.object ? this.item.object : {};
      if (!this.item.objectOfObject) {
        this.item.object[this.item.objectOfObjectName] = {};
      } else {
        this.item.object[this.item.objectOfObjectName] =
          this.item.objectOfObject;
      }
      this.results = this.item.object[this.item.objectOfObjectName][
        this.item.name
      ]
        ? this.item.object[this.item.objectOfObjectName][this.item.name].value
          ? this.item.object[this.item.objectOfObjectName][this.item.name].value
              .toString()
              .split(',')
          : this.item.object[this.item.objectOfObjectName][this.item.name]
              .toString()
              .split(',')
        : [];
    } else {
      this.item.object = this.item.object ? this.item.object : {};
      this.results = this.item.object[this.item.name]
        ? this.item.object[this.item.name].value
          ? this.item.object[this.item.name].value.toString().split(',')
          : this.item.object[this.item.name].toString().split(',')
        : [];
    }
    this.result = this.results.join(',');
    this.searchFor = this.searchFor;
    this.limitToOne = this.limitToOne;
    this.setValue = this.setValue;

    if (this.searchFor) {
      this.disableSearchType = true;
      this.select.selectedSearch = this.searchFor;
      switch (this.searchFor) {
        case 'BEHAVIORS':
          this.title = 'Regex Search for Behaviors';
          break;
        case 'PROMOTIONS':
          this.title = 'Regex Search for Promotions';
          break;
        case 'LOCATIONS':
          this.title = 'Regex Search for Locations';
          break;
        case 'INSTRUMENTTYPES':
          this.title = 'Regex Search for Instrument Types';
          break;
        case 'COMMUNICATIONS':
          this.title = 'Search for Communications';
          break;
        case 'REWARD':
          this.title = 'Search for Reward Types';
          break;
      }
    }
  }

  doRegexSearch = function () {
    if (!this.searchPattern) {
      this.searchPattern = '';
    }
    if (this.select.selectedSearch === 'PROMOTIONS') {
      this.promotionService
        .getPromotionsByRegex({ pattern: this.searchPattern })
        .subscribe((data: any) => {
          if (data.success) {
            this.searchResults = parseResponse(data);
            $('#select-all-cb').prop('checked', false);
          }
        });
    } else if (this.select.selectedSearch === 'BEHAVIORS') {
      this.behaviorsService
        .getBehaviorsByRegex({ pattern: this.searchPattern })
        .subscribe((data: any) => {
          if (data.success) {
            this.searchResults = parseResponse(data);
            $('#select-all-cb').prop('checked', false);
          }
        });
    } else if (this.select.selectedSearch === 'LOCATIONS') {
      this.locationService
        .getLocationsByRegex({ pattern: this.searchPattern })
        .subscribe((data: any) => {
          if (data.success) {
            this.searchResults = parseResponse(data);
            $('#select-all-cb').prop('checked', false);
          }
        });
    } else if (this.select.selectedSearch === 'INSTRUMENTTYPES') {
      this.instrumentTypeService
        .getInstrumentTypesByRegex({ pattern: this.searchPattern })
        .subscribe((data: any) => {
          if (data.success) {
            this.searchResults = parseResponse(data);
            $('#select-all-cb').prop('checked', false);
          }
        });
    } else if (this.select.selectedSearch === 'COMMUNICATIONS') {
      this.communicationsService
        .getCommunications({ pattern: this.searchPattern })
        .subscribe((data: any) => {
          if (data.success) {
            this.searchResults = parseResponse(data);
            $('#select-all-cb').prop('checked', false);
          }
        });
    } else if (this.select.selectedSearch === 'REWARD') {
      this.rewardTypeService
        .getRewardTypes({ search: this.searchPattern })
        .subscribe((data: any) => {
          if (data.success) {
            this.searchResults = parseResponse(data);
            $('#select-all-cb').prop('checked', false);
          }
        });
    }
  };

  selectAllCb = function ($event) {
    var $selectAllCb = $('#select-all-cb');

    if (this.results.length > 0) {
      this.results.splice(0, this.results.length);
      $('[id^=cb-]:checked').each(function () {
        $(this).prop('checked', false);
      });
      $selectAllCb.prop('checked', false);
    } else {
      this.results = this.searchResults.map(
        (result) => result.code || result.name
      );
      $('[id^=cb-]').each(function () {
        $(this).prop('checked', true);
      });
      $selectAllCb.prop('checked', true);
    }

    this.result = this.results.join(',');
  };

  updateSelectedCodes = function (code) {
    var $selectAllCb = $('#select-all-cb');
    const codeIdx = this.results.indexOf(code);

    if (!this.limitToOne) {
      if (codeIdx !== -1) {
        this.results.splice(codeIdx, 1);
      } else {
        this.results.push(code);
      }
    } else {
      if (codeIdx !== -1) {
        this.results.splice(codeIdx, 1);
      } else {
        this.results.splice(0, this.results.length);
        this.results.push(code);
      }

      $('.proc-check:checkbox:checked').each(function () {
        if (this.id) {
          const parts = this.id.split('? cb-');
          if (parts.length > 1) {
            const id = parts[1].split(' : cb-')[0];
            if (id !== code) {
              $(this).prop('checked', false);
            }
          }
        }
      });
    }

    const checked = this.results.length === this.searchResults.length;
    $selectAllCb.prop('checked', checked);

    this.result = this.results.join(',');
  };

  insertCodes = function () {
    if (this.setValue) {
      this.item.object[this.item.name] = [];
      this.item.object[this.item.name].value = this.result;
    } else {
      if (!this.item.objectOfObjectName) {
        this.item.object[this.item.name] = this.result;
      } else {
        this.item.object[this.item.objectOfObjectName][this.item.name] =
          this.result;
      }
    }
    this.debouncer.next(
      this.fieldTypeRadio == 0 ? this.result : this.searchPattern
    );
    this.activeModal.close();
  };

  clearAll = function () {
    this.results = [];
    this.searchResults = [];
    this.searchPattern = '';
    this.result = '';
    $('#select-all-cb').prop('checked', false);
  };

  cancel(): void {
    this.activeModal.close();
  }
}
